import { TabNav } from "../../../../patterns/TabNav.js";
import type { AccountTabsContent } from "../../accountContent.js";

/** Settings' sub-tabs (Profile, Shipping, Verification, Advanced), each its own URL. */
export function AccountSettingsNav({ label, items }: AccountTabsContent) {
  return <TabNav label={label} items={items} variant="chips" />;
}
